export const AUTH_API = "v1/auth";
export const SECURITY_API = "v1/user";
